{
  "title": "Sanctuary",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level abjuration",
  "level": 1,
  "castingTime": "1 bonus action",
  "range": "30 feet",
  "components": "V, S, M (a small silver mirror)",
  "duration": "1 minute",
  "description": [
    "You ward a creature within range against attack. Until the spell ends, any creature who targets the warded creature with an attack or a harmful spell must first make a Wisdom saving throw. On a failed save, the creature must choose a new target or lose the attack or spell. This spell doesn’t protect the warded creature from area effects, such as the explosion of a fireball.",
    "If the warded creature makes an attack, casts a spell that affects an enemy, or deals damage to another creature, this spell ends."
  ],
  "spellLists": ["artificer", "cleric"]
}
